'use strict';
// Smooth scrolling without altering the URL
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  });
});

// Header Mega menu color with addClass
document.addEventListener("DOMContentLoaded", (event) => {
  const videoCardLinks = document.querySelectorAll(".header__megamenu-item, .header-mega-menu");

  videoCardLinks.forEach((el) => {
    el.addEventListener("mouseover", (e) => {
      e.target.closest(".header-wrapper").classList.add("megamenu-hovered");
    });
    el.addEventListener("mouseout", (e) => {
      e.target.closest(".header-wrapper").classList.remove("megamenu-hovered");
    });
  });
});


// Swipe to slide multicolum

const mediaQuery = window.matchMedia('(max-width: 575px)')
 
function handleTabletChange(e) {
  // Check if the media query is true
  if (e.matches) {
    // Then log the following message to the console
    const slides = document.getElementsByClassName('multicolumn-item-slide');
    let index = 1;
    
    function slideshow() {
        // reset slide index counter if it exceeds the maximum limit
        if (index >= slides.length) index = 0;
        
        // show the current slide
        if (!slides[index].classList.contains('multicolumn-item-show'))
            slides[index].classList.add('multicolumn-item-show');
    
        // hide the previous slide, only if index is > 0
        if (index > 0 && slides[index - 1].classList.contains('multicolumn-item-show'))
            slides[index - 1].classList.remove('multicolumn-item-show');
        // if index is 0 or less it means the slideshow has restarted so hide the last element which is at the end of the container array    
        else if (index <= 0 && slides[slides.length - 1].classList.contains('multicolumn-item-show'))
            slides[slides.length - 1].classList.remove('multicolumn-item-show');
    
        index++;
    }
    
    setInterval(slideshow, 2000);
  }
}
 
// Register event listener
mediaQuery.addListener(handleTabletChange)

// Initial check
handleTabletChange(mediaQuery)



















